import HttpService from './baseHttp'

//我的账户
export const HttpAccountInfo = (data = {}, config) => HttpService.get('/api/v2/account/myAccount', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })
//客户管理
export const HttpCustomerMageFindPage = (data = {}, config) => HttpService.get('/api/v2/customerManage/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })


// 客户基础费用
// 列表、查看、编辑、删除、导出
export const HttpGetBaseChargeList = (data = {}) => HttpService.get('/api/v2/carrierBaseCharge/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })

export const HttpGetBaseChargeOne = (data = {}) => HttpService.get('/api/v2/carrierBaseCharge/findById', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })

export const HttpSaveBaseChargeOne = (data) => HttpService.post('/api/v2/carrierBaseCharge/saveOne', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID }, baseURL: process.env.VUE_APP_APIURL_FBB })

export const HttpDeleteBaseChargeOne = (data = {}) => HttpService.get('/api/v2/carrierBaseCharge/deleteById', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })

export const HttpExportBaseCharge = (data, config) => HttpService.get('/api/v2/carrierBaseCharge/export', { ...config, params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

// 客户承运商基础报价
// 列表、查看、编辑、删除、导入
export const HttpGetBaseRateList = (data = {}) => HttpService.get('/api/v2/carrierBaseRate/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })
export const HttpGetBaseRateOne = (data = {}) => HttpService.get('/api/v2/carrierBaseRate/findById', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })
export const HttpSaveBaseRateOne = (data) => HttpService.post('/api/v2/carrierBaseRate/saveOne', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID }, baseURL: process.env.VUE_APP_APIURL_FBB })
export const HttpDeleteBaseRateOne = (data = {}) => HttpService.get('/api/v2/carrierBaseRate/delete', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })
export const HttpExportBaseRate = (data, config) => HttpService.get('/api/v2/carrierBaseRate/export', { ...config, params: data, baseURL: process.env.VUE_APP_APIURL_FBB });
export const HttpImportBaseRate = (data, config) => HttpService.get('/api/v2/carrierBaseRate/import', { ...config, params: data, baseURL: process.env.VUE_APP_APIURL_FBB });


// 客户折扣率
// 列表、查看、编辑、删除、添加、导出、折扣率复制
export const HttpGetDisacountRateList = (data = {}) => HttpService.get('/api/v2/customerCarrierDiscount/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })

export const HttpGetDisacountRateOne = (data = {}) => HttpService.get('/api/v2/customerCarrierDiscount/findById', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })

export const HttpUpdateDisacountRateeOne = (data) => HttpService.post('/api/v2/customerCarrierDiscount/updateOne', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID }, baseURL: process.env.VUE_APP_APIURL_FBB })

export const HttpDeleteDisacountRateOne = (data = {}) => HttpService.get('/api/v2/customerCarrierDiscount/deleteById', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })

// export const HttpDeleteDisacountRateList = (data = {}) => HttpService.get('/api/v2/customerCarrierDiscount/deleteByIds', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })

export const HttpSaveDisacountRateeOne = (data) => HttpService.post('/api/v2/customerCarrierDiscount/saveOne', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID }, baseURL: process.env.VUE_APP_APIURL_FBB })

export const HttpExportDisacountRate = (data, config) => HttpService.get('/api/v2/customerCarrierDiscount/export', { ...config, params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

export const HttpCopyDisacountRate = (data) => HttpService.post('/api/v2/customerCarrierDiscount/copyCustomerRate', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID }, baseURL: process.env.VUE_APP_APIURL_FBB })


// 客户最低收费
// 列表、查看、编辑、删除、添加、导出、折扣率复制
export const HttpGetMinimumChargeList = (data = {}) => HttpService.get('/api/v2/customerMinimumCharge/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })

export const HttpGetMinimumChargeOne = (data = {}) => HttpService.get('/api/v2/customerMinimumCharge/findById', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })

export const HttpUpdateMinimumChargeOne = (data) => HttpService.post('/api/v2/customerMinimumCharge/updateOne', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID }, baseURL: process.env.VUE_APP_APIURL_FBB })

export const HttpDeleteMinimumChargeOne = (data = {}) => HttpService.get('/api/v2/customerMinimumCharge/deleteById', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })

// export const HttpDeleteMinimumChargeList = (data = {}) => HttpService.get('/api/v2/customerMinimumCharge/deleteByIds', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })

export const HttpSaveMinimumChargeOne = (data) => HttpService.post('/api/v2/customerMinimumCharge/saveOne', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID }, baseURL: process.env.VUE_APP_APIURL_FBB })

export const HttpExportMinimumCharge = (data, config) => HttpService.get('/api/v2/customerMinimumCharge/export', { ...config, params: data, baseURL: process.env.VUE_APP_APIURL_FBB });

export const HttpCopyMinimumCharge = (data) => HttpService.post('/api/v2/customerMinimumCharge/copyCustomerMinimumCost', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID }, baseURL: process.env.VUE_APP_APIURL_FBB })


// 承运商分区维护
// 列表、查看、删除、添加/编辑、导出
export const HttpGetAreaMaintainList = (data = {}) => HttpService.get('/api/v2/carrierZone/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })

export const HttpGetAreaMaintainOne = (data = {}) => HttpService.get('/api/v2/carrierZone/findById', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })

export const HttpDeleteAreaMaintainOne = (data = {}) => HttpService.get('/api/v2/carrierZone/deleteById', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })

export const HttpSaveAreaMaintainOne = (data) => HttpService.post('/api/v2/carrierZone/saveOne', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID }, baseURL: process.env.VUE_APP_APIURL_FBB })

export const HttpExportAreaMaintain = (data, config) => HttpService.get('/api/v2/carrierZone/export', { ...config, params: data, baseURL: process.env.VUE_APP_APIURL_FBB });


// 偏远地区邮编
// 列表、查看、删除、添加/编辑、导出
export const HttpGetRemozeZipCodeList = (data = {}) => HttpService.get('/api/v2/remoteAreaZipcode/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })

export const HttpGetRemozeZipCodeOne = (data = {}) => HttpService.get('/api/v2/remoteAreaZipcode/findById', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })

export const HttpDeleteRemozeZipCodeOne = (data = {}) => HttpService.get('/api/v2/remoteAreaZipcode/deleteById', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })

export const HttpSaveRemozeZipCodeOne = (data) => HttpService.post('/api/v2/remoteAreaZipcode/saveOne', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID }, baseURL: process.env.VUE_APP_APIURL_FBB })

export const HttpExportRemozeZipCode = (data, config) => HttpService.get('/api/v2/remoteAreaZipcode/export', { ...config, params: data, baseURL: process.env.VUE_APP_APIURL_FBB });



// 附加费规则配置
// 列表、查看、删除、添加/编辑、
export const HttpGetSurChargeRuleList = (data = {}) => HttpService.get('/api/v2/addonRule/findByPage', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })

export const HttpGetSurChargeRuleOne = (data = {}) => HttpService.get('/api/v2/addonRule/findById', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })

export const HttpDeleteSurChargeRuleOne = (data = {}) => HttpService.get('/api/v2/addonRule/deleteById', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })

export const HttpSaveSurChargeRuleOne = (data) => HttpService.post('/api/v2/addonRule/saveOne', data, { headers: { "Content-Type": "application/json" }, params: { contextId: global.SYSID }, baseURL: process.env.VUE_APP_APIURL_FBB })

// 筛选承运商服务
export const HttpCarrierList = (data = {}) => HttpService.get('/api/v2/SystemDeliveryCarrier/findAllCarrier', { params: data, baseURL: process.env.VUE_APP_APIURL_FBB })
